import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import Container from 'partials/Container';
import SingleHeader from 'partials/SingleHeader';
import Image from 'partials/Image';
import WP from 'WP';
import css from 'css';
import ContentWithSidebar from 'partials/ContentWithSidebar';
import RelatedProjects from 'partials/modules/RelatedProjects';
import { redirect404, removeLinebreaks, stripTags } from 'helpers';
import HeadMeta from 'partials/HeadMeta';
import { FacebookShareLink, TwitterShareLink } from 'partials/ShareLinks';
import Slider from 'partials/Slider';
import Loader from 'partials/Loader';

import { setCurrentView } from 'store';

class SingleProject extends Component {

    constructor() {
        super();

        this.state = {
            project: null,
            related: []
        }
    }

    componentWillMount() {
        this.mounted = true;

        api.getProjectBySlug(this.props.match.params.slug)
            .then(resp => {
                if(resp.data[0]) {
                    //console.log('PROJECT: ', resp.data[0]);
                    if(this.mounted) {
                        this.setState({ project: resp.data[0] });
                        this.props.setCurrentView(resp.data[0]);

                        // get related projects
                        api.getRelatedPosts(resp.data[0].id)
                            .then(resp => {
                                if(this.mounted) 
                                    this.setState({ related: resp.data });
                            });
                    }
                } else {                    
                    redirect404();
                }
            })
            .catch(e => console.log(e));

    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const { project, related } = this.state;
        const featuredImage = project ? project.featured_image_src : null;
        //console.log(project);
        return (
            <Wrapper>

                <Loader loaded={project} />
 
                {project &&
                    <Container>

                        <HeadMeta
                            title={removeLinebreaks(stripTags(project.acf.title || project.title.rendered))+' - HLM'}
                            description=""
                            ogUrl=""
                            ogType=""
                            ogTitle=""
                            ogDescription=""
                            ogImage=""
                        />

                        <SingleHeader title={project.acf.title || project.title.rendered} excerpt={project.acf.excerpt} />
                        
                        {project.acf.show_featured_image !== false &&
                            <div>
                                {!project.acf.gallery &&
                                    <Image image={featuredImage} className="projectImage" background ratio="1259:783" />
                                }
                                {project.acf.gallery &&
                                    <Slider 
                                        slides={project.acf.gallery.map(slide => <Image image={slide.image} background ratio="1259:783" />)} 
                                        bleedOnMobile
                                        withBullets
                                    />
                                }
                            </div>
                        }

                        <ProjectDetails>
                            <div className="left">
                                {project.acf.start_year &&
                                    <div className="detail" style={{minWidth:'100px'}}>
                                        <label>{WP.trans.year || 'År'}</label>
                                        {project.acf.start_year}
                                        {project.acf.end_year && <span /> }
                                        {project.acf.end_year}
                                    </div>
                                }
                                {project.acf.type.length > 0 &&
                                <div className="detail">
                                    <label>{WP.trans.type || 'Type'}</label>
                                    {project.acf.type.map(type => type.name).join(', ')}
                                </div>
                                }
                                {project.acf.status &&
                                    <div className="detail">
                                        <label>{WP.trans.status || 'Status'}</label>
                                        {project.acf.status}
                                    </div>
                                }
                                {project.acf.attachment &&
                                    <div className="detail">
                                        <label>{WP.trans.download || 'Laste ned'}</label>
                                        <a href={project.acf.attachment} className="downloadLink" target="_blank" download={project.title.rendered} title="Download PDF">PDF</a> 
                                    </div>
                                }
                            </div>
                            <div className="right">
                                <div>
                                    {project.acf.location &&
                                        <div className="detail">
                                            <label>{WP.trans.location || 'Sted'}</label>
                                            {project.acf.location}
                                        </div>
                                    }
                                    {project.acf.size &&
                                        <div className="detail">
                                            <label>{WP.trans.size || 'Størrelse'}</label>
                                            {project.acf.size} m&sup2;
                                        </div>
                                    }
                                    {project.acf.client &&
                                        <div className="detail">
                                            <label>{WP.trans.client || 'Byggherre'}</label>
                                            {project.acf.client}
                                        </div>
                                    }
                                </div>
                                <div>
                                    <div className="detail share">
                                        <label>{WP.trans.share || 'Del'}</label>
                                        <FacebookShareLink url={project.link} title={project.acf.title || project.title.rendered} />
                                        <TwitterShareLink url={project.link} title={project.acf.title || project.title.rendered} />
                                    </div>
                                </div>
                            </div>
                        </ProjectDetails>

                        <ContentWithSidebar data={project} />

                    </Container>
                }

                {project && related &&
                    <RelatedProjects data={{
                        projects: related, 
                        archive_link: false, 
                        title: WP.trans.relatedProjects,
                        smallTitile: true,
                        background: 'white',
                        itemHoverBackground: 'gray',
                    }} />
                }
            </Wrapper>
        );
    }
}

const actions = {
    setCurrentView
}

export default connect(null, actions)(withRouter(SingleProject));

const Wrapper = styled.article`
    display:block;
    position:relative;
    width:100%;
    .projectImage {
        @media (max-width:768px) {
            width: calc(100% + 50px);
            margin-left: -25px;
            margin-right:-25px;
        }
        @media (max-width:480px) {
            padding:0;
            height:190px;
        }
    }
`

const ProjectDetails = styled.div`
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top:20px;
    .left {
        width:45%;
        display:flex;
        @media (max-width:1080px) {
            width:100%;
            margin-bottom:20px;
        }
        @media (max-width:768px) {
            margin-bottom:0px;
            flex-wrap: wrap;
            .detail {
                width:100%;
                border-bottom: 1px solid #8C8C8C;
                padding: 10px 0 8px 0;
                margin-right:0;
                display:flex;
                label {
                    display: inline-block;
                    min-width:100px;
                }
            }
        }
    }
    .right {
        width: ${css.sizes.rightColumn};
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        > div:last-child {
            text-align:right;
        }
        @media (max-width:1080px) {
            width:100%;
        }
        @media (max-width:768px) {
            > div, .detail {
                width:100%;
            }
            > div:last-child {
                text-align:left;
            }
            .detail {
                border-bottom: 1px solid #8C8C8C;
                padding: 10px 0 8px 0;
                label {
                    display: inline-block;
                    width:100px;
                }
                &.share {
                    border-bottom:0;
                    label {
                        display:block;
                    }
                }
            }
        }
    }

    .detail {
        font-size:14px;
        display:inline-block;
        margin-right: 40px;
        &:last-child {
            margin-right:0;
        }
        label {
            color: #797979;
            display:block;
            margin-bottom: 5px;
        }
        span {
            display: inline-block;
            width:14px;
            height:1px;
            background: #000;
            position:relative;
            margin: 0 3px;
            top:-4px;
            @media (max-width:768px) {
                top:9px;
            }
        }
        a {
            margin-left: 5px;
            &.downloadLink {
                margin-left:0;
            }
            @media (max-width:768px) {
                margin-left:0;
                margin-right:10px;
            }
        }

        @media (max-width:1080px) {
            min-width:100px;
        }
    }
`


// WEBPACK FOOTER //
// ./src/views/SingleProject.js